export default __webpack_public_path__ + "static/media/bg4.7185f25b.png";